module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwIDwI6JbKIwQAAAThJREFUOMvdkbFKA0EQhmc2go0kd+lvZy97QgxKFMHKwlSCFr5FLPIKATEPkGexSKNtlHSCiBKQ5LJiJ5LL2SRGdyxCwAsatdQp/5/5mP8fgD8/qa+M0sE+pobjEzedGfXjQfvXAByOmwiQR8Cyk3Fb0SDq/BiQI9UQDIF9hQKkuCkATt200+7H0c3cPGvbm+h76lxLFSaBtKOlYt/zd+desASLDYEQWAvFKI5G2pP1bNZ57BrTcp1Ma3KJe9ePo+vpjkjy+PJ54S0XPvTiQMoKCFEGxgtNtNw15oyRS4j2KdHVZ1G0J6sgRI3Z5hnFngCoA/Bqx5jbb/+qPVnVRC+a5PpUU6RqmtRQExXmLgeePNSkrCZZnPV8UscTj4KPeqIDRtwC4JWOub+aBYSmd2QRKgy4Af9r3gFStWhIQR8BoAAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowupdouble.png
 ** module id = 344
 ** module chunks = 0 1
 **/